import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { userDetail } from 'src/environments/userDetail';
import { HttpHeaders ,HttpClient,HttpBackend } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Router} from '@angular/router';
import { NotificationService } from "src/app/service/notification.service";
import * as CryptoJS from 'crypto-js';
import { language } from "src/environments/language";
import * as $ from 'jquery';
import { Base64 } from 'js-base64';
import * as XLSX from 'xlsx';
import { switchMap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ApiService {
 
  
  public token='';
  public previlleges:any;
  userid:any;
  public tmsToken='';
  private userLoggedIn = new Subject<boolean>();
  public regCountInterval;

  public dataAccess='';
  public skipLocationChange=environment.SKIP_LOCATION_CHANGE;
  constructor(private http : HttpClient, private router : Router, private notification : NotificationService,private httpBackend: HttpBackend) {
    this.http = new HttpClient(httpBackend);
    let userDetails=localStorage.getItem('userDetail');
    this.token=localStorage.getItem('access-token');
    this.userid=this.decryptData(localStorage.getItem('token-detail'));
    if(localStorage.getItem('tmsToken'))
    {
      let tmsTokenDet=this.decryptData(localStorage.getItem('tmsToken'));
      this.tmsToken=tmsTokenDet.token;
    }
    else
      this.tmsToken=''; 
   
    if(userDetails)
    {
      let user=this.decryptData(userDetails);
      userDetail.loginname=user.loginname;
      userDetail.password=user.password;
    }
    this.getVersionDetails((version)=>{

    });
    this.serverHitting=0;

  }
  updateUserID()
  {
    this.userid=this.decryptData(localStorage.getItem('token-detail'));
  }
  navigateByUrl(url,options=null)
  {
    if(options==null)
    {
      options={ skipLocationChange: environment.SKIP_LOCATION_CHANGE }
    }
    this.router.navigateByUrl(url,options);
  }
  checkValidUser(loginname:any,password:any): Observable<any>
  {
    return new Observable((observer)=>{
      
      this.http.post(environment.API_URL+'api/auth/auth-check',{loginname:loginname,password:password}).subscribe((res)=>{
        let response=JSON.parse(JSON.stringify(res));
        localStorage.setItem('HASHVALUE',this.encryptData({loginname:loginname,password:password}));
        observer.next(response);
      },(error)=>{
        let finalRes={status:'error',message:'Incorrect username/password'};
        observer.next(finalRes);
        
      });
    });
  }
  getAccessUser(loginname:any,password:any): Observable<any>
  {
    return new Observable((observer)=>{
      
      this.http.post(environment.API_URL+'api/auth/get-access',{loginname:loginname,password:password}).subscribe((res)=>{
        let response=JSON.parse(JSON.stringify(res));
        // localStorage.setItem('HASHVALUE',this.encryptData({loginname:loginname,password:password}));
        observer.next(response);
      },(error)=>{
        let finalRes={status:'error',message:'Incorrect username/password'};
        observer.next(finalRes);
        
      });
    });
  }
  getToken(loginname:any,password:any): Observable<any>
  {
    console.log('responseresponse')
    this.userid=this.decryptData(localStorage.getItem('token-detail'));
    return new Observable((observer)=>{
      localStorage.setItem('HASHVALUE',this.encryptData({loginname:loginname,password:password}));
      this.http.post(environment.API_URL+'api/auth/token',{loginname:loginname,password:password}).subscribe((res)=>{
        let response=JSON.parse(JSON.stringify(res));
        console.log('responseresponsesam',response)
        let finalRes={};
        if(response.access)
        {
          console.log('responserespdfffffonse',response)
          finalRes={status:'success',message:'Credentials are matched',access:response.access,refresh:response.refresh}
          localStorage.setItem('access-token',response.access);
          this.token=response.access; 
          finalRes={
            ...finalRes,
            ...response
          };
          // if((finalRes.role_id)) 
          //   this.getPrivileges(finalRes.role_id);
          // console.log('finalres',finalRes.role_id);
        }
        if(response.status)
        {
          if(response.status==2)
          {
            finalRes=response;
          }
        }
        observer.next(finalRes);
      },(error)=>{
        let finalRes={status:'error',message:'Incorrect username/password'};
        observer.next(finalRes);
        
      });
    });
    
  }

  getApplicantToken(loginname:any,password:any): Observable<any>
  {
    console.log('responseresponse')
    this.userid=this.decryptData(localStorage.getItem('token-detail'));
    return new Observable((observer)=>{
      localStorage.setItem('HASHVALUE',this.encryptData({patient_number:loginname,password:password}));
      this.http.post(environment.API_URL+'api/applicant-auth/token',{patient_number:loginname,password:password}).subscribe((res)=>{
        let response=JSON.parse(JSON.stringify(res));
        console.log('responseresponse',response)
        let finalRes={};
        if(response.access)
        {
          console.log('responserespdfffffonse',response)
          finalRes={status:'success',message:'Credentials are matched',access:response.access,refresh:response.refresh}
          localStorage.setItem('access-token',response.access);
          this.token=response.access; 
          finalRes={
            ...finalRes,
            ...response
          };
        }
        if(response.status)
        {
          if(response.status==2)
          {
            finalRes=response;
          }
        }
        observer.next(finalRes);
      },(error)=>{
        let finalRes={status:'error',message:'Incorrect username/password'};
        observer.next(finalRes);
        
      });
    });
    
  }

  applicantLogoutLog()
  {
    this.userid=this.decryptData(localStorage.getItem('token-detail'));
    let applicant_data=this.decryptData(localStorage.getItem('applicant-token-detail'));
    
    this.displayLoading(true);
    this.postAPI(environment.API_URL + "api/auth/logout",{user_id:this.userid.user_id}).subscribe((res)=>{
        this.displayLoading(false);
        this.postAPI(environment.API_URL + "api/applicant-auth/logout",{applicant_id:applicant_data.user_id}).subscribe((res)=>{
          localStorage.removeItem('applicant-token-detail');
        });

        this.notification.displayMessage(res.message);
        localStorage.removeItem('liveCounter');
        localStorage.removeItem('skipCounter');
        localStorage.removeItem('tmsToken');
        localStorage.removeItem('userDetail');
        localStorage.removeItem('token-detail');
        this.router.navigateByUrl('/authenticate/applicant-login');
      });
    
  }

  getClientTimeZone()
  {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  serverHitting=0;
  // getAPI(url:any) : Observable<any>
  // {
  //   let clientTimeZone=this.getClientTimeZone();
  //   this.userid=this.decryptData(localStorage.getItem('token-detail'));
  //   if(this.userid && this.userid.currentAccess)
  //   {
  //     let country=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].country?this.userid.currentAccess.locations[0].country.id:''):'';
  //     let country_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].country?this.userid.currentAccess.locations[0].country.code:''):'';
  //     let country_name=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].country?this.userid.currentAccess.locations[0].country.name:''):'';
  //     let region=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].region?this.userid.currentAccess.locations[0].region.id:''):'';
  //     let region_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].region?this.userid.currentAccess.locations[0].region.code:''):'';
  //     let state=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].state?this.userid.currentAccess.locations[0].state.id:''):'';
  //     let state_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].state?this.userid.currentAccess.locations[0].state.code:''):'';
  //     let city=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].city?this.userid.currentAccess.locations[0].city.id:''):'';
  //     let city_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].city?this.userid.currentAccess.locations[0].city.code:''):'';
  //     let centre=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].centre?this.userid.currentAccess.locations[0].centre.id:''):'';
  //     let centre_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].centre?this.userid.currentAccess.locations[0].centre.code:''):'';
  //     this.dataAccess=this.encryptData({country:country,country_code:country_code,country_name:country_name,region:region,region_code:region_code,state:state,state_code:state_code,city:city,city_code:city_code,centre:centre,centre_code:centre_code});
  //   }
  //   let tmsHeader = {};
  //   if(localStorage.getItem('tmsToken'))
  //   {
  //     let tmsTokenDet=this.decryptData(localStorage.getItem('tmsToken'));
  //     this.tmsToken=tmsTokenDet.token;
  //   }
  //   else
  //     this.tmsToken=''; 

  //   if(this.tmsToken!='')
  //   {
  //     tmsHeader={'X-Api-Key':this.tmsToken};
  //   }
  //   return new Observable((observer)=>{
  //     let headers = {'Authorization':`Bearer `+ this.token,'timeout':'6000','authorized-role':(this.userid.role_code?this.userid.role_code:''),'authorized-by':(this.userid.role_id?(this.userid.role_id).toString():''),'authorized-data':(this.dataAccess),'clientTimeZone':clientTimeZone};
  //     /*let headers = {'Authorization':`Bearer `+ this.token,'timeout':'6000','authorized-role':(this.userid.role_code?this.userid.role_code:''),'authorized-by':(this.userid.role_id?(this.userid.role_id).toString():'')};*/
  //     headers = {
  //       ...headers,
  //       ...tmsHeader
  //     }
  //     let httpOptions = {
  //       headers : new HttpHeaders(headers)
  //     };
  //     this.http.get(url,httpOptions).subscribe((res)=>{
  //       observer.next(res);
  //     },(error)=>{
  //       if(error.status==401)
  //       {
  //         if(this.serverHitting>2)
  //         {
  //           this.notification.displayMessage('Your session expired. Please logout and login');
  //           this.serverHitting=0; 
  //         }
  //         else
  //         {
  //           this.serverHitting=this.serverHitting+1;
  //           this.getToken(userDetail.loginname,userDetail.password).subscribe((res)=>{
  //             this.getAPI(url).subscribe((res)=>{
  //               observer.next(res);
  //             });
  //           });
  //         }
          
  //       }
  //       else
  //         observer.next(error);
  //     }); 
  //   });
  // }

  postAPI(url:any, data:any,headerOptions={}) : Observable<any>
  {
 
    let clientTimeZone=this.getClientTimeZone();
    this.userid=this.decryptData(localStorage.getItem('token-detail'));
    if(this.userid && this.userid.currentAccess)
    {
      
      let country=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].country?this.userid.currentAccess.locations[0].country.id:''):'';
      let country_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].country?this.userid.currentAccess.locations[0].country.code:''):'';
      let country_name=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].country?this.userid.currentAccess.locations[0].country.name:''):'';
      let region=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].region?this.userid.currentAccess.locations[0].region.id:''):'';
      let region_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].region?this.userid.currentAccess.locations[0].region.code:''):'';
      let state=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].state?this.userid.currentAccess.locations[0].state.id:''):'';
      let state_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].state?this.userid.currentAccess.locations[0].state.code:''):'';
      let city=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].city?this.userid.currentAccess.locations[0].city.id:''):'';
      let city_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].city?this.userid.currentAccess.locations[0].city.code:''):'';
      let centre=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].centre?this.userid.currentAccess.locations[0].centre.id:''):'';
      let centre_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].centre?this.userid.currentAccess.locations[0].centre.code:''):'';
      this.dataAccess=this.encryptData({country:country,country_code:country_code,country_name:country_name,region:region,region_code:region_code,state:state,state_code:state_code,city:city,city_code:city_code,centre:centre,centre_code:centre_code});
    }
    let tmsHeader = {};
    if(localStorage.getItem('tmsToken'))
    {
      let tmsTokenDet=this.decryptData(localStorage.getItem('tmsToken'));
      this.tmsToken=tmsTokenDet.token;
    }
    else
      this.tmsToken='';
    if(this.tmsToken!='')
    {
      tmsHeader={'X-Api-Key':this.tmsToken};
    }
    let refreshtoken='';
    if(localStorage.getItem('access-token-details'))
    {
      refreshtoken=JSON.parse(localStorage.getItem('access-token-details')).refresh;
    }
    return new Observable((observer)=>{
      
      let headers = {'Authorization':`Bearer `+ this.token,'timeout':'6000','authorized-role':(this.userid && this.userid.role_code?this.userid.role_code:''),'authorized-by':(this.userid && this.userid.role_id?(this.userid.role_id).toString():''),'authorized-data':(this.dataAccess),'clientTimeZone':clientTimeZone,'refresh-token':refreshtoken};
      /*let headers = {'Authorization':`Bearer `+ this.token,'timeout':'6000','authorized-role':(this.userid.role_code?this.userid.role_code:''),'authorized-by':(this.userid.role_id?(this.userid.role_id).toString():'')};*/
      headers = {
        ...headers,
        ...headerOptions,
        ...tmsHeader
      }
      let httpOptions = {
        headers : new HttpHeaders(headers)
      };
 
      this.http.post(url,data,httpOptions).subscribe((res)=>{
        observer.next(res);
      },(error)=>{
        if(error.status==401)
        {
          if(this.serverHitting>2)
          {
            this.notification.displayMessage('Your session expired. Please logout and login');
            this.serverHitting=0;
          }
          else
          {
            this.serverHitting=this.serverHitting+1;
            this.getToken(userDetail.loginname,userDetail.password).subscribe((res)=>{
              this.postAPI(url,data,headerOptions).subscribe((res)=>{
                observer.next(res);
              });
            });
          }
          
        }
        else if(error.status==503)
        {
          if(this.serverHitting>2)
          {
            this.notification.displayMessage('Failed to reach the server');
            this.serverHitting=0;
            observer.next({status:environment.ERROR_CODE,message:'Failed to reach the server.Please contact IT team'});
          }
          else
          {
            this.serverHitting=this.serverHitting+1;
            setTimeout(()=>{
              // this.notification.displayMessage('Attempt '+this.serverHitting);
              this.postAPI(url,data,headerOptions).subscribe((res)=>{
                observer.next(res);
              });
            },1000);
          }
        }
        else if(error.status==500)
          {
            // Internal server error
              this.notification.displayMessage('Internal server error.Please contact IT team');
              this.serverHitting=0;
              observer.next({status:environment.ERROR_CODE,message:'Internal server error.Please contact IT team'});
            
          }
        else if(error.status==403)
        {
          this.notification.displayMessage('You are requested to force logout');
          this.applicationLogoutLog();
        }
        else if(error.status==405)
          {
            // Method Not Allowed
              this.notification.displayMessage('Server error.Please contact IT team');
              this.serverHitting=0;
              observer.next({status:environment.ERROR_CODE,message:'Server error.Please contact IT team'});
            
          }
        else
          observer.next(error);
      });
    });
  }
 
 
  getAPI(url:any) : Observable<any>
  {
    let clientTimeZone=this.getClientTimeZone();
    this.userid=this.decryptData(localStorage.getItem('token-detail'));
    if(this.userid && this.userid.currentAccess)
    {
      let country=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].country?this.userid.currentAccess.locations[0].country.id:''):'';
      let country_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].country?this.userid.currentAccess.locations[0].country.code:''):'';
      let country_name=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].country?this.userid.currentAccess.locations[0].country.name:''):'';
      let region=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].region?this.userid.currentAccess.locations[0].region.id:''):'';
      let region_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].region?this.userid.currentAccess.locations[0].region.code:''):'';
      let state=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].state?this.userid.currentAccess.locations[0].state.id:''):'';
      let state_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].state?this.userid.currentAccess.locations[0].state.code:''):'';
      let city=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].city?this.userid.currentAccess.locations[0].city.id:''):'';
      let city_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].city?this.userid.currentAccess.locations[0].city.code:''):'';
      let centre=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].centre?this.userid.currentAccess.locations[0].centre.id:''):'';
      let centre_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].centre?this.userid.currentAccess.locations[0].centre.code:''):'';
      this.dataAccess=this.encryptData({country:country,country_code:country_code,country_name:country_name,region:region,region_code:region_code,state:state,state_code:state_code,city:city,city_code:city_code,centre:centre,centre_code:centre_code});
    }
    let tmsHeader = {};
    if(localStorage.getItem('tmsToken'))
    {
      let tmsTokenDet=this.decryptData(localStorage.getItem('tmsToken'));
      this.tmsToken=tmsTokenDet.token;
    }
    else
      this.tmsToken='';
 
    if(this.tmsToken!='')
    {
      tmsHeader={'X-Api-Key':this.tmsToken};
    }
    return new Observable((observer)=>{
      let headers = {'Authorization':`Bearer `+ this.token,'timeout':'6000','authorized-role':(this.userid && this.userid.role_code?this.userid.role_code:''),'authorized-by':(this.userid && this.userid.role_id?(this.userid.role_id).toString():''),'authorized-data':(this.dataAccess),'clientTimeZone':clientTimeZone};
      /*let headers = {'Authorization':`Bearer `+ this.token,'timeout':'6000','authorized-role':(this.userid.role_code?this.userid.role_code:''),'authorized-by':(this.userid.role_id?(this.userid.role_id).toString():'')};*/
      headers = {
        ...headers,
        ...tmsHeader
      }
      let httpOptions = {
        headers : new HttpHeaders(headers)
      };
      this.http.get(url,httpOptions).subscribe((res)=>{
        observer.next(res);
      },(error)=>{
        if(error.status==401)
        {
          if(this.serverHitting>2)
          {
            this.notification.displayMessage('Your session expired. Please logout and login');
            this.serverHitting=0;
          }
          else
          {
            this.serverHitting=this.serverHitting+1;
            this.getToken(userDetail.loginname,userDetail.password).subscribe((res)=>{
              this.getAPI(url).subscribe((res)=>{
                observer.next(res);
              });
            });
          }
          
        }
        else if(error.status==503)
        {
          if(this.serverHitting>2)
          {
            this.notification.displayMessage('Failed to reach the server');
            this.serverHitting=0;
            observer.next({status:environment.ERROR_CODE,message:'Failed to reach the server.Please contact IT team'});
          }
          else
          {
            this.serverHitting=this.serverHitting+1;
            setTimeout(()=>{
              this.getAPI(url).subscribe((res)=>{
                observer.next(res);
              });
            },1000);
          }
        }
        else if(error.status==403)
        {
          this.notification.displayMessage('You are requested to force logout');
          this.applicationLogoutLog();
        }
        else if(error.status==500)
          {
            // Internal server error
              this.notification.displayMessage('Internal server error.Please contact IT team');
              this.serverHitting=0;
              observer.next({status:environment.ERROR_CODE,message:'Internal server error.Please contact IT team'});
            
          }
        else if(error.status==405)
          {
            // Method Not Allowed
              this.notification.displayMessage('Server error.Please contact IT team');
              this.serverHitting=0;
              observer.next({status:environment.ERROR_CODE,message:'Server error.Please contact IT team'});
          }
        else
          observer.next(error);
      });
    });
  }


  // postAPI(url:any, data:any,headerOptions={}) : Observable<any>
  // {
  //   let clientTimeZone=this.getClientTimeZone();
  //   this.userid=this.decryptData(localStorage.getItem('token-detail'));
  //   if(this.userid && this.userid.currentAccess)
  //   {
      
  //     let country=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].country?this.userid.currentAccess.locations[0].country.id:''):'';
  //     let country_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].country?this.userid.currentAccess.locations[0].country.code:''):'';
  //     let country_name=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].country?this.userid.currentAccess.locations[0].country.name:''):'';
  //     let region=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].region?this.userid.currentAccess.locations[0].region.id:''):'';
  //     let region_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].region?this.userid.currentAccess.locations[0].region.code:''):'';
  //     let state=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].state?this.userid.currentAccess.locations[0].state.id:''):'';
  //     let state_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].state?this.userid.currentAccess.locations[0].state.code:''):'';
  //     let city=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].city?this.userid.currentAccess.locations[0].city.id:''):'';
  //     let city_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].city?this.userid.currentAccess.locations[0].city.code:''):'';
  //     let centre=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].centre?this.userid.currentAccess.locations[0].centre.id:''):'';
  //     let centre_code=this.userid.currentAccess.locations.length>0?(this.userid.currentAccess.locations[0].centre?this.userid.currentAccess.locations[0].centre.code:''):'';
  //     this.dataAccess=this.encryptData({country:country,country_code:country_code,country_name:country_name,region:region,region_code:region_code,state:state,state_code:state_code,city:city,city_code:city_code,centre:centre,centre_code:centre_code});
  //   }
  //   let tmsHeader = {};
  //   if(localStorage.getItem('tmsToken'))
  //   {
  //     let tmsTokenDet=this.decryptData(localStorage.getItem('tmsToken'));
  //     this.tmsToken=tmsTokenDet.token;
  //   }
  //   else
  //     this.tmsToken=''; 
  //   if(this.tmsToken!='')
  //   {
  //     tmsHeader={'X-Api-Key':this.tmsToken};
  //   }
  //   return new Observable((observer)=>{
      
  //     let headers = {'Authorization':`Bearer `+ this.token,'timeout':'6000','authorized-role':(this.userid.role_code?this.userid.role_code:''),'authorized-by':(this.userid.role_id?(this.userid.role_id).toString():''),'authorized-data':(this.dataAccess),'clientTimeZone':clientTimeZone};
  //     /*let headers = {'Authorization':`Bearer `+ this.token,'timeout':'6000','authorized-role':(this.userid.role_code?this.userid.role_code:''),'authorized-by':(this.userid.role_id?(this.userid.role_id).toString():'')};*/
  //     headers = {
  //       ...headers,
  //       ...headerOptions,
  //       ...tmsHeader
  //     }
  //     let httpOptions = {
  //       headers : new HttpHeaders(headers)
  //     };

  //     this.http.post(url,data,httpOptions).subscribe((res)=>{
  //       observer.next(res);
  //     },(error)=>{
  //       if(error.status==401)
  //       {
  //         if(this.serverHitting>2)
  //         {
  //           this.notification.displayMessage('Your session expired. Please logout and login');
  //           this.serverHitting=0; 
  //         }
  //         else
  //         {
  //           this.serverHitting=this.serverHitting+1;
  //           this.getToken(userDetail.loginname,userDetail.password).subscribe((res)=>{
  //             this.postAPI(url,data,headerOptions).subscribe((res)=>{
  //               observer.next(res);
  //             });
  //           });
  //         }
          
  //       }
  //       else
  //         observer.next(error);
  //     }); 
  //   });
  // }

  saveBiometricDetails(visa_number,status,failure_reason='',skip_reason='',id='',biometric_type='')
  {
    this.postAPI(environment.API_URL+"transaction/gro/applicant_biometric/details",{visa_number:visa_number,status:status,id:'',failure_reason:failure_reason,skip_reason:skip_reason,biometric_type:biometric_type}).subscribe((biometric)=>{
      let biometric_id=biometric.data.id?biometric.data.id:''
      let encounter_id=biometric.encounter_id?biometric.encounter_id:''
      localStorage.setItem('biometric-details',this.encryptData(biometric_id))
      localStorage.setItem('encounter-id',this.encryptData(encounter_id))
    });
  }

  downloadAPI(url:any, data:any,headerOptions={}) : Observable<any>
  {
    this.userid=this.decryptData(localStorage.getItem('token-detail'));
    let tmsHeader = {};
    if(localStorage.getItem('tmsToken'))
    {
      let tmsTokenDet=this.decryptData(localStorage.getItem('tmsToken'));
      this.tmsToken=tmsTokenDet.token;
    }
    else
      this.tmsToken=''; 
    if(this.tmsToken!='')
    {
      tmsHeader={'X-Api-Key':this.tmsToken};
    }
    return new Observable((observer)=>{

      let headers = {'Authorization':`Bearer `+ this.token,'timeout':'6000','responseType':'application/octet-stream'};
      headers = {
        ...headers,
        ...headerOptions,
        ...tmsHeader
      }
      let httpOptions = {
        headers : new HttpHeaders(headers)
      };

      this.http.post<Blob>(url,data,httpOptions).subscribe((res)=>{
        observer.next(res);
      },(error)=>{
        if(error.status==401)
        {
          this.getToken(userDetail.loginname,userDetail.password).subscribe((res)=>{
            this.downloadAPI(url,data,headerOptions).subscribe((res)=>{

              observer.next(res);
            });
          });
        }
        else
          observer.next(error);
      }); 
    });
  }

  saveAccessControlNotification(startDateTime='',endDateTime='',location='',visa_number='')
  {
    let counterDet='';
    if(localStorage.getItem('liveCounter'))
    {
      counterDet=this.decryptData(localStorage.getItem('liveCounter')).counter.CounterName;
      let counterNo=parseInt(counterDet.replace(/^\D+/g, ''));
      this.postAPI(environment.API_URL+"transaction/access-control-notification",{visa_number:visa_number,startDateTime:startDateTime,location:location,endDateTime:endDateTime,counterNo:counterNo}).subscribe((res)=>{
      });
    }
    
  }

getPageAction() 
  {    
    let data = localStorage.getItem('token-detail');
    if(data)
    {
      let access = this.decryptData(data);
      let modules = JSON.parse(access.permissions);



      // console.log('modules',modules)

      let components = modules.map(value => value.components);
      let mergedComponents = [].concat.apply([], components);

      let attributes = mergedComponents.map(value => value.attributes);
      let mergedAttributes = [].concat.apply([], attributes);

      
      let currentPath=this.router.url;
      currentPath=currentPath.substring(1);

      let currentPageAction = mergedComponents.map(value => value.url==currentPath?value.action:'');

      var filtered = currentPageAction.filter(function (el) {
        return el != '';
      });
      // console.log('filtered',filtered);
      let finalActions=filtered.length>0?filtered[0]:'';

      if(finalActions!='')
      {
        let filterStatus = finalActions.map(value => value.status==true?value:'');
        var filteredStatus = filterStatus.filter(function (el) {
          return el != '';
        });
        return filteredStatus;
      }
      else 
      {
        let currentPageAction = modules.map(value => value.url==currentPath?value.action:'');
        var filtered = currentPageAction.filter(function (el) {
          return el != '';
        });
        let finalActions=filtered.length>0?filtered[0]:'';
        if(finalActions!='')
        {
          let filterStatus = finalActions.map(value => value.status==true?value:'');
          var filteredStatus = filterStatus.filter(function (el) {
            return el != '';
          });
          return filteredStatus;
        }
        else{
          return '';
        }
      }
    }

  }



  secugenErrorString(ErrorCode) {
        var Description;
        switch (ErrorCode) {
            // 0 - 999 - Comes from SgFplib.h
            // 1,000 - 9,999 - SGIBioSrv errors 
            // 10,000 - 99,999 license errors
            case 51:
                Description = "System file load failure";
                break;
            case 52:
                Description = "Sensor chip initialization failed";
                break;
            case 53:
                Description = "Device not found";
                break;
            case 54:
                Description = "Fingerprint image capture timeout";
                break;
            case 55:
                Description = "No device available";
                break;
            case 56:
                Description = "Driver load failed";
                break;
            case 57:
                Description = "Wrong Image";
                break;
            case 58:
                Description = "Lack of bandwidth";
                break;
            case 59:
                Description = "Device Busy";
                break;
            case 60:
                Description = "Cannot get serial number of the device";
                break;
            case 61:
                Description = "Unsupported device";
                break;
            case 63:
                Description = "SgiBioSrv didn't start; Try image capture again";
                break;
            default:
                Description = "Unknown error code or Update code to reflect latest result";
                break;
        }
        return Description;
  }
  postCaptureSecugen(data?:any) : Observable<any>
  {
    return new Observable((observer)=>{
      let httpOptions = {
        headers : new HttpHeaders({'Content-Type':'text/plain'})
      };
      this.http.post(environment.SECUGEN_CAPTURE,data,httpOptions).subscribe(function(res){
        res={
          ...res,
          ...{status:200}
        };
        observer.next(res);
      },function(error){
        error.status=404;
        observer.next(error);
      }); 
    });
  }
  matchScoreSecugen(template_1,template_2) : Observable<any>
  {
    return new Observable((observer)=>{
      if (template_1 == "" || template_2 == "") {
          alert("Please scan two fingers to verify!!");
          return;
      }
      let httpOptions = {
        headers : new HttpHeaders({'Content-Type':'text/plain;charset=UTF-8'})
      };
      // let data={template1:encodeURIComponent(template_1),template2:encodeURIComponent(template_2),licstr:encodeURIComponent(''),templateFormat:'ISO'}
      var params = "template1=" + encodeURIComponent(template_1);
      params += "&template2=" + encodeURIComponent(template_2);
      params += "&licstr=" + encodeURIComponent('');
      params += "&templateFormat=" + "ISO";
      this.http.post(environment.SECUGEN_MATCH,params,httpOptions).subscribe(function(res){
        res={
          ...res,
          ...{status:200}
        };
        observer.next(res);
      },function(error){
        error.status=404;
        observer.next(error);
      }); 
    });

    /*return new Observable((observer)=>{
        if (template_1 == "" || template_2 == "") {
            alert("Please scan two fingers to verify!!");
            return;
        }
        var uri = environment.SECUGEN_MATCH;

        var xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
                let fpobject = JSON.parse(xmlhttp.responseText);
                fpobject={
                  ...fpobject,
                  ...{status:200}
                };
                observer.next(fpobject);
            }
            else if (xmlhttp.status == 404) {
                observer.next({status:xmlhttp.status});
            }
        }

        xmlhttp.onerror = function () {
            observer.next({status:xmlhttp.status});
        }
        var params = "template1=" + encodeURIComponent(template_1);
        params += "&template2=" + encodeURIComponent(template_2);
        params += "&licstr=" + encodeURIComponent('');
        params += "&templateFormat=" + "ISO";
        xmlhttp.open("POST", uri, false);
        xmlhttp.send(params);
    });*/
    
  }
  /*matchScoreSecugen(template_1,template_2) : Observable<any>
  {
    return new Observable((observer)=>{
        if (template_1 == "" || template_2 == "") {
            alert("Please scan two fingers to verify!!");
            return;
        }
        var uri = environment.SECUGEN_MATCH;

        var xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
                let fpobject = JSON.parse(xmlhttp.responseText);
                fpobject={
                  ...fpobject,
                  ...{status:200}
                };
                observer.next(fpobject);
            }
            else if (xmlhttp.status == 404) {
                observer.next({status:xmlhttp.status});
            }
        }

        xmlhttp.onerror = function () {
            observer.next({status:xmlhttp.status});
        }
        var params = "template1=" + encodeURIComponent(template_1);
        params += "&template2=" + encodeURIComponent(template_2);
        params += "&licstr=" + encodeURIComponent('');
        params += "&templateFormat=" + "ISO";
        xmlhttp.open("POST", uri, false);
        xmlhttp.send(params);
    });
    
  }*/
  encryptData(data) {

    try {
      return CryptoJS.AES.encrypt(JSON.stringify(data), environment.CRYPTO_KEY).toString();
    } catch (e) {
      console.log(e);
    }
  }

  decryptData(data) {

    try {
      const bytes = CryptoJS.AES.decrypt(data, environment.CRYPTO_KEY);
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return data;
    } catch (e) {
      //console.log(e);
      return '';
    }
  }

  loggedIn() {
     return localStorage.getItem('token-detail');
   }
 
  setUserLoggedIn(userLoggedIn: boolean) {
    this.userLoggedIn.next(userLoggedIn);
  }

  getUserLoggedIn(): Observable<boolean> {
    return this.userLoggedIn.asObservable();
  }
  signOutCounter(callback)
  {
    if(localStorage.getItem('tmsToken'))
    {
      let tmsTokenDet=this.decryptData(localStorage.getItem('tmsToken'));
      this.tmsToken=tmsTokenDet.token;
    }
    else
      this.tmsToken=''; 
    if(this.tmsToken)
    {
      this.postAPI(environment.API_URL + "tms/signout",{},{'X-Api-Key':this.tmsToken}).subscribe({
      next:data=>{
          /*if(data.status==environment.SUCCESS_CODE) {
              localStorage.removeItem('liveCounter');
              localStorage.removeItem('tmsToken');
            }else if(data.status==environment.ERROR_CODE) {
              this.notification.displayMessage(data.response.message);
            } else {
              this.notification.displayMessage(language[environment.DEFAULT_LANG].unableSubmit);
            }*/
            localStorage.removeItem('liveCounter');
            localStorage.removeItem('tmsToken');
            localStorage.removeItem('skipCounter');
            callback(data);
          // console.log(data.data);
        },
        error:err=>{
          // console.log(err);
        }
      });
    }
    else
    {
      callback({status:environment.SUCCESS_CODE});
    }
  }

  applicationLogoutLog()
  {
    this.userid=this.decryptData(localStorage.getItem('token-detail'));

    if(environment.TOKENACCESS && (this.userid.role_code=='nurse' || this.userid.role_code=='gro' || this.userid.role_code=='gp' || this.userid.role_code=='xray'))
    {
      this.displayLoading(true);
      this.signOutCounter((data)=>{
        this.displayLoading(false);
        if(data.status==environment.SUCCESS_CODE) {
          this.postAPI(environment.API_URL + "api/auth/logout",{user_id:this.userid.user_id}).subscribe((res)=>{
            this.notification.displayMessage(res.message);
            localStorage.removeItem('applicant-token-detail')
            localStorage.removeItem('liveCounter');
            localStorage.removeItem('skipCounter');
            localStorage.removeItem('tmsToken');
            localStorage.removeItem('userDetail');
            if(this.userid.role_code=="Phlebo"){
              localStorage.removeItem('token-detail');
              this.router.navigateByUrl('authenticate/phlebotomist-login');
              
             }
             else{
              localStorage.removeItem('token-detail');
              localStorage.removeItem('applicant-token-detail')
              this.router.navigateByUrl('/');
             }
             
          });

        }else if(data.status==environment.ERROR_CODE) {
          this.notification.displayMessage(data.response.message);
        } else {
          this.notification.displayMessage(language[environment.DEFAULT_LANG].unableSubmit);
        }
      });
    }
    else
    {
      this.displayLoading(true);
      this.postAPI(environment.API_URL + "api/auth/logout",{user_id:this.userid.user_id}).subscribe((res)=>{
          this.displayLoading(false);
          this.notification.displayMessage(res.message);
          localStorage.removeItem('applicant-token-detail')
          localStorage.removeItem('liveCounter');
          localStorage.removeItem('skipCounter');
          localStorage.removeItem('tmsToken');
          localStorage.removeItem('userDetail');
         if(this.userid.role_code=="Phlebo"){
          localStorage.removeItem('token-detail');
          this.router.navigateByUrl('authenticate/phlebotomist-login');
          
         }
         else{
          localStorage.removeItem('token-detail');
          localStorage.removeItem('applicant-token-detail')
          this.router.navigateByUrl('/');
         }
         
        });
    }
  }

  checkUploadedViews(accession_number,callback)
  {
    this.postAPI(environment.API_URL + "transaction/check-uploaded-views",{accession_number:accession_number}).subscribe((res)=>{
      if(res.status==environment.SUCCESS_CODE)
      {
        if(res.isUploaded && res.isUploaded==true)
        {
          callback({allow:true,message:'Image uploaded successfully'});
        }
        else if(res.isUploaded==false)
        {
          callback({allow:false,message:(res.response)+' views are not uploaded yet. Please wait'});
        }
        else
        {
          callback({allow:false,message:""});
        }
      }
      else
        callback({allow:false,message:res.message});
    });
  }

  getConfiguration(code='')
  {
    if(this.userid)
    {
      // console.log("this.userid.configuration",this.userid.configuration)
      if(this.userid.configuration)
      {
        let config = (this.userid.configuration).filter(config=>{return config.code==code});
        return config.length>0?config[0].value:'';
      }
    }
    return '';
  }

  startWorkFlow(process_definition_id:any, data:any) : Observable<any>
  {
    return new Observable((observer)=>{
      let headers = {'Authorization':`BASIC `+ btoa(environment.JBPM_USER+':'+environment.JBPM_PASSWORD),'timeout':'6000'};
      let httpOptions = {
        headers : new HttpHeaders(headers)
      };
      this.http.post(environment.JBPM_URL+'startWorkflow/'+environment.JBPM_CONTAINER_ID+'/'+process_definition_id,data,httpOptions).subscribe((res:any)=>{
        if(res)
        {
          
          localStorage.setItem('JBPM_INSTANCE_ID',this.encryptData(res.taskProcessInstanceId));
          localStorage.setItem('JBPM_TASK_ID',this.encryptData(res.taskId));
        }
        observer.next(res);
      },(error)=>{
        observer.next({serverResponse:JSON.stringify({status:environment.ERROR_CODE,message:'Failed to connect JBPM server'})});
        //observer.next(error);
          
      }); 
    });
  }
  completeTask(data={}) : Observable<any>
  {

    let JBPM_INSTANCE_ID=localStorage.getItem('JBPM_INSTANCE_ID')?this.decryptData(localStorage.getItem('JBPM_INSTANCE_ID')):'';
    let JBPM_TASK_ID=localStorage.getItem('JBPM_TASK_ID')?this.decryptData(localStorage.getItem('JBPM_TASK_ID')):'';
    return new Observable((observer)=>{
      if(JBPM_INSTANCE_ID && JBPM_TASK_ID)
      {
        let tmsHeader = {};
          if(this.tmsToken!='')
          {
            tmsHeader={'X-Api-Key':this.tmsToken};
          }

          data ={
            ...data,
            ...({'headers':tmsHeader})
          };
          let headers = {'Authorization':`BASIC `+ btoa(environment.JBPM_USER+':'+environment.JBPM_PASSWORD),'timeout':'6000'};
          
          let httpOptions = {
            headers : new HttpHeaders(headers)
          };
          this.http.post(environment.JBPM_URL+'completeTask/'+this.userid.user_id+'/'+JBPM_INSTANCE_ID+'/'+JBPM_TASK_ID+'?containerId='+environment.JBPM_CONTAINER_ID,data,httpOptions).subscribe((res:any)=>{
            if(res)
              localStorage.setItem('JBPM_TASK_ID',this.encryptData(res.taskId));
            observer.next(res);
          },(error)=>{
            observer.next({serverResponse:JSON.stringify({status:environment.ERROR_CODE,message:'Failed to connect JBPM server',error:error})});
            //observer.next(error);
              
          }); 
      }
      else
        observer.next({status:environment.ERROR_CODE,message:'Instance id and task id is missing'});

      });
  }

  getTask() : Observable<any>
  {
    let JBPM_INSTANCE_ID=localStorage.getItem('JBPM_INSTANCE_ID')?this.decryptData(localStorage.getItem('JBPM_INSTANCE_ID')):'';
    return new Observable((observer)=>{
      if(JBPM_INSTANCE_ID)
      {
          let headers = {'Authorization':`BASIC `+ btoa(environment.JBPM_USER+':'+environment.JBPM_PASSWORD),'timeout':'6000','Content-Type':'applicant/json'};
          
          let httpOptions = {
            headers : new HttpHeaders(headers)
          };
          this.http.get(environment.JBPM_URL+'getTaskDetails/'+this.userid.user_id+'/'+JBPM_INSTANCE_ID,httpOptions).subscribe((res:any)=>{
            observer.next(res);
          },(error)=>{
            observer.next({serverResponse:JSON.stringify({status:environment.ERROR_CODE,message:'Failed to connect JBPM server'})});
            //observer.next(error);
              
          }); 
      }
      else
        observer.next({status:environment.ERROR_CODE,message:'Task id is missing'});

      });
  }
  getWorkflowSVG(instance_id)
  {
    return environment.JBPM_URL+'rest/server/containers/'+environment.JBPM_CONTAINER_ID+'/images/processes/instances/'+instance_id;
  }
  displayLoading(show=true)
  {
    if(show)
    {
      $('body').append(`<div class="body-load">
         <div class="loader-icon">
          <div class="loader"><img src="assets/images/logo-animated.gif"></div>
         </div>
      </div>`);
    }
    else
    {
      $('.body-load').fadeOut(600,function(){
        $(this).remove();
      });
    }
  }

  disableClicks(show=true)
  {
    if(show)
    {
      $('body').append(`<div class="disable-click"></div>`);
    }
    else
    {
      $('.disable-click').remove();
    }
  }
  inArray(needle, haystack) {
      var length = haystack.length;
      for(var i = 0; i < length; i++) {
          if(haystack[i] == needle) return true;
      }
      return false;
  }

  encrypt(str, secret) {
      str = Math.random().toString(36).substring(2, 10) + str;
      var _strkey = Base64.decode(secret);
      _strkey.split(",");
      var text = CryptoJS.enc.Utf8.parse(str);
      var Key = CryptoJS.enc.Base64.parse(_strkey.split(",")[1]); //secret key
      var IV = CryptoJS.enc.Base64.parse(_strkey.split(",")[0]); //16 digit
      var encryptedText = CryptoJS.AES.encrypt(text, Key, { keySize: 128 / 8, iv: IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
      var b64 = encryptedText.toString();
      var e64 = CryptoJS.enc.Base64.parse(b64);
      var eHex = e64.toLocaleString(CryptoJS.enc.Hex);
      return eHex.toUpperCase();
  }

  decrypt(str, secret) {
      try {
          var _strkey = Base64.decode(secret);
          var reb64 = CryptoJS.enc.Hex.parse(str);
          var text = reb64.toString(CryptoJS.enc.Base64);
          var Key = CryptoJS.enc.Base64.parse(_strkey.split(",")[1]); //secret key
          var IV = CryptoJS.enc.Base64.parse(_strkey.split(",")[0]); //16 digit
          var decryptedText = CryptoJS.AES.decrypt(text, Key, { keySize: 128 / 8, iv: IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
          return decryptedText.toString(CryptoJS.enc.Utf8).slice(4); //binascii.unhexlify(decryptedText)
      } catch (e) {
          // console.log("Error", e)
      }
  }
  getCurrentCountry()
  {
    let tokenDetails=this.userid;
    // console.log("tokenDetails",tokenDetails)
    return tokenDetails.currentAccess.locations?tokenDetails.currentAccess.locations[0].country.id:'';
  }
  getCurrentCity()
  {
    let tokenDetails=this.userid;
    // console.log('tokenDetailstokenDetails',tokenDetails)
    return tokenDetails.currentAccess.locations.length>0 && tokenDetails.currentAccess.locations[0].city?tokenDetails.currentAccess.locations[0].city.id:'';
  }
  getCurrentCountryName()
  {
    let tokenDetails=this.userid;
    // console.log("tokenDetails",tokenDetails)
    return tokenDetails.currentAccess.locations.length>0 && tokenDetails.currentAccess.locations[0].country?tokenDetails.currentAccess.locations[0].country.name:'';
  }

  getCurrentCityName()
  {
    let tokenDetails=this.userid;
    // console.log('tokenDetailstokenDetails',tokenDetails)
    return tokenDetails.currentAccess.locations.length>0 && tokenDetails.currentAccess.locations[0].city?tokenDetails.currentAccess.locations[0].city.name:'';
  }

  getCurrentCountryCode()
  {
    let tokenDetails=this.userid;
    return tokenDetails.currentAccess.locations.length>0?tokenDetails.currentAccess.locations[0].country.code:'';
  }
  getCurrentCityCode()
  {
    let tokenDetails=this.userid;
    return tokenDetails.currentAccess.locations.length>0 && tokenDetails.currentAccess.locations[0].city?tokenDetails.currentAccess.locations[0].city.code:'';
  }
  getCurrentCentre()
  {
    let tokenDetails=this.userid;
    return tokenDetails.currentAccess.locations.length>0 && tokenDetails.currentAccess.locations[0].centre?tokenDetails.currentAccess.locations[0].centre.id:null;
  }

  getCurrentRoleName()
  {
    // return 'moh';
    let tokenDetails=this.userid;
    console.log('tokenDetails-mgn',tokenDetails.currentAccess);
    
    return tokenDetails.currentAccess.user_role?tokenDetails.currentAccess.user_role.name:null;
  }
  getCurrentRole()
  {
    // return 'moh';
    let tokenDetails=this.userid;
    // console.log("getCurrentRole",tokenDetails);
    return tokenDetails.currentAccess.user_role?tokenDetails.currentAccess.user_role.code:null;
  }
  getAccessLocations()
  {
    let tokenDetails=this.userid;

    let countries=[];
    let regions=[];
    let states=[];
    let cities=[];
    let centres=[];
    let role={"locations":[]};
    
    for(let j=0;j<(tokenDetails.data_access).length;j++)
    {
      if(tokenDetails.data_access[j].id==tokenDetails.currentAccess.id)
        role=tokenDetails.data_access[j];
    }
    if(role)
    {
      for(let j=0;j<role.locations.length;j++)
      {
        if(role.locations[j].country)
          countries.push(role.locations[j].country.id);
        if(role.locations[j].region)
          regions.push(role.locations[j].region.id);
        if(role.locations[j].state)
          states.push(role.locations[j].state.id);
        if(role.locations[j].city)
          cities.push(role.locations[j].city.id);
        if(role.locations[j].centre)
          centres.push(role.locations[j].centre.id);
      }
    }
    return {countries:countries,regions:regions,states:states,cities:cities,centres:centres};
  }

  profileImageUpdate$ = new Subject<string>();


  getMaskedVal(data:any){
    var maskedValue='';
    if(data){
      for(let i= 1; i<=data.toString().length;i++){
        maskedValue +='X'
      }
        return maskedValue;
    }

  }

  getAssignedDetails(visa_number:any,callback){
    this.postAPI(environment.API_URL + "transaction/save/assigned-details",{visa_number:visa_number}).subscribe((res)=>{
      if(res.status==environment.SUCCESS_CODE) {
        let data =res.data[0]
        let applicant_info={};
      let applicant={
        personal:data.appointment.applicant.personal[0],
        encounter:data.appointment.applicant.encounter[0],
        communication:data.appointment.applicant.communication[0],
      };
      let dataNew =this.decryptData(localStorage.getItem('applicant-details'));
      applicant_info['totalLength']=dataNew.totalLength?dataNew.totalLength:0;
      applicant_info['appointment']=data.appointment;
      applicant_info['applicant']=applicant;
      applicant_info['identity']=data.appointment.applicant.identity[0];
      applicant_info['token']="";
      applicant_info['id']=this.userid.role_id;
      applicant_info['reason']=data.appointment?data.reason:'';
      applicant_info['sub_reason']=data.appointment?data.sub_reason:'';
      applicant_info['is_confirmatory']=data.is_confirmatory?data.is_confirmatory:'';
      applicant_info['is_fit']=data.is_fit?data.is_fit:'';
      applicant_info['fit_on']=data.fit_on?data.fit_on:'';
      applicant_info['fit_by_role']=data.fit_by_role?data.fit_by_role:'';
      applicant_info['comments']=data.appointment?data.comments:'';
      applicant_info['close_status']=data.close_status?data.close_status:'';
      applicant_info['reopen_notes1']=data.reopen_notes1?data.reopen_notes1:'';
      applicant_info['reopen_notes2']=data.reopen_notes2?data.reopen_notes2:'';
      applicant_info['reopen_notes3']=data.reopen_notes3?data.reopen_notes3:'';
      applicant_info['reopen_status1']=data.reopen_status1?data.reopen_status1:'';
      applicant_info['reopen_status2']=data.reopen_status2?data.reopen_status2:'';
      applicant_info['reopen_status3']=data.reopen_status3?data.reopen_status3:'';
      applicant_info['reopen_by1']=data.reopen_by1?data.reopen_by1:'';
      applicant_info['reopen_by2']=data.reopen_by2?data.reopen_by2:'';
      applicant_info['reopen_by3']=data.reopen_by3?data.reopen_by3:'';
      applicant_info['reopen_on']=data.reopen_on?data.reopen_on:'';
      applicant_info['assigner_role']=data.assigner_role?data.assigner_role:'';
      applicant_info['assigned_role']=data.assigned_role?data.assigned_role:'';
      applicant_info['is_autofit']=data.is_autofit?data.is_autofit:'';
      
      localStorage.setItem('applicant-details',this.encryptData(applicant_info));
      callback(applicant_info);

      }
    });
  }



  verifyFingerprint(FingerPrintImage,fingerIndex,visa_number,callback)
  {
    this.postAPI(environment.API_URL + "biomet/verify-fingerprint",{aurn:visa_number,FingerIndex:fingerIndex,FingerPrintImage:FingerPrintImage}).subscribe((res)=>{
      if(res.status==environment.SUCCESS_CODE) {
         let response=res.response;
         if(response.matchStatus==true)         
            callback({status:environment.SUCCESS_CODE,message:"finger print match success"});
         else
            callback({status:environment.ERROR_CODE,message:"Fingerprint does not match"});

      }else if(res.status==environment.ERROR_CODE) {
        callback({status:environment.ERROR_CODE,message:res.message});
      } else {
        callback({status:environment.ERROR_CODE,message:language[environment.DEFAULT_LANG].unableSubmit});
      }
    });
  }
  versionDetails:any;
  getVersionDetails(callback)
  {
    this.postAPI(environment.API_URL + "version/latest-version",{}).subscribe((res)=>{
      this.versionDetails=res.version;
      callback(res);
    });
  }

  redirectToCorrespondingPage(processID)
  {

    
    switch(processID)
    { 
      case 'admin': case 1:
        this.navigateByUrl('dashboard/admin',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'gro': case 2:
        this.navigateByUrl('/gro/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'nurse': case 3:
        this.navigateByUrl('/nurse/dashboard-nurse',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'xray': case 4:
        this.navigateByUrl('/gp/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'gp': case 5:
        this.navigateByUrl('/gp/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'lab': case 6:
        this.navigateByUrl('/lab-process/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'call-center': case 7:
        this.navigateByUrl('/call-centre/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'c-manager': case 8:
        this.navigateByUrl('/centre-manager/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'c-spec': case 9:
        this.navigateByUrl('centre-speciality/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'cgp': case 10:
        this.navigateByUrl('/cgp/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'moh': case 11:
        this.navigateByUrl('/moh/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'moh-lab': case 12:
        this.navigateByUrl('/moh-lab/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'moi': case 13:
        this.navigateByUrl('/moi/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'autofit': case 14:
        this.navigateByUrl('/autofit/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'exit': case 15:
        this.navigateByUrl('/exit/dashboard',{ skipLocationChange: this.skipLocationChange });
      break; 
      case 'sr-moh': case 16:
        this.navigateByUrl('/moh/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'operation': case 19:
        this.navigateByUrl('/moh/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'security': case 17:
        this.navigateByUrl('/moh/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'rbtr': case 18:
        this.navigateByUrl('/moh/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'radiologist': case 21:
        this.navigateByUrl('/gp/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'radiologist': case 22:
        this.navigateByUrl('/gp/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'radiologist': case 23:
        this.navigateByUrl('/gp/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'radiologist': case 24:
        this.navigateByUrl('/gp/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'RadTechnician': case 25:
        this.navigateByUrl('/nurse/dashboard-nurse',{ skipLocationChange: this.skipLocationChange });
      break;     
      case 'radiologist': case 26:
        this.navigateByUrl('/gp/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'radiologist': case 27:
        this.navigateByUrl('/gp/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'client': case 28:
        this.navigateByUrl('client/dashboard-client',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'Applicant': case 29:
        this.navigateByUrl('client/dashboard-applicant',{ skipLocationChange: this.skipLocationChange });
      break;
      case 'ENT': case 30:
        this.navigateByUrl('/gp/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      case "Phlebotomist": case 32:
        this.navigateByUrl('phlebo/dashboard',{ skipLocationChange: this.skipLocationChange });
      break;
      
      /*default:
        this.navigateByUrl('');
      break; */
    }
    /*switch(processID)
    { 
      case 'admin': case 1:
      this.navigateByUrl('dashboard/admin',{skipLocationChange: true});
      break;
      case 'gro': case 2:
      this.navigateByUrl('/gro/dashboard',{skipLocationChange: true});
      break;
      case 'nurse': case 3:
      this.navigateByUrl('/nurse/dashboard-nurse',{skipLocationChange: true});
      break;
      case 'xray': case 4:
      this.navigateByUrl('/xray/dashboard',{skipLocationChange: true});
      break;
      case 'gp': case 5:
      this.navigateByUrl('/gp/dashboard',{skipLocationChange: true});
      break;
      case 'lab': case 6:
      this.navigateByUrl('/lab-process/dashboard',{skipLocationChange: true});
      break;
      case 'call-center': case 7:
        this.navigateByUrl('/call-centre/dashboard',{skipLocationChange: true});
      break;
      case 'c-manager': case 8:
        this.navigateByUrl('/centre-manager/dashboard',{skipLocationChange: true});
      break;
      case 'c-spec': case 9:
        this.navigateByUrl('centre-speciality/dashboard',{skipLocationChange: true});
      break;
      case 'cgp': case 10:
        this.navigateByUrl('/cgp/dashboard',{skipLocationChange: true});
      break;
      case 'moh': case 11:
        this.navigateByUrl('/moh/dashboard',{skipLocationChange: true});
      break;
      case 'moh-lab': case 12:
        this.navigateByUrl('/moh-lab/dashboard',{skipLocationChange: true});
      break;
      case 'moi': case 13:
        this.navigateByUrl('/moi/dashboard',{skipLocationChange: true});
      break;
      case 'autofit': case 14:
        this.navigateByUrl('/autofit/dashboard',{skipLocationChange: true});
      break;
      case 'exit': case 15:
        this.navigateByUrl('/exit/dashboard',{skipLocationChange: true});
      break; 
      case 'sr-moh': case 16:
        this.navigateByUrl('/moh/dashboard',{skipLocationChange: true});
      break;
      default:
        this.navigateByUrl('');
      break; 
    }*/
  }

  export2Excel(element,filename)
  {
    const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, filename+'.xlsx');
    
  }

  post_to_url(path, params, method) {
    $('#downloadForm').remove();
    method = method || "post";

    let form = document.createElement("form");
    form.setAttribute("target", "_blank");
    form.setAttribute("id", 'downloadForm');
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for(let key in params) {
        if(params.hasOwnProperty(key)) {
            let hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", key);
            hiddenField.setAttribute("value", params[key]);

            form.appendChild(hiddenField);
         }
    }
    document.body.appendChild(form);
    form.submit();
    // this.submitToPopup(form);
  }

  getCurrentAssignedDetails(data,callback){
    this.postAPI(environment.API_URL + "transaction/save/assigned-details",data).subscribe((res)=>{
      if(res.status==environment.SUCCESS_CODE) {
        let data =res.data[0]
        let applicant_info={};
        let applicant={
          personal:data.appointment.applicant.personal[0],
          encounter:data.appointment.applicant.encounter[0],
          communication:data.appointment.applicant.communication[0],
        };
        let dataNew =this.decryptData(localStorage.getItem('applicant-details'));
        applicant_info['totalLength']=dataNew.totalLength?dataNew.totalLength:0;
        applicant_info['appointment']=data.appointment;
        applicant_info['applicant']=applicant;
        applicant_info['identity']=data.appointment.applicant.identity[0];
        applicant_info['token']="";
        applicant_info['id']=this.userid.role_id;
        applicant_info['reason']=data.appointment?data.reason:'';
        applicant_info['sub_reason']=data.appointment?data.sub_reason:'';
        applicant_info['is_confirmatory']=data.is_confirmatory?data.is_confirmatory:'';
        applicant_info['is_fit']=data.is_fit?data.is_fit:'';
        applicant_info['fit_on']=data.fit_on?data.fit_on:'';
        applicant_info['fit_by_role']=data.fit_by_role?data.fit_by_role:'';
        applicant_info['comments']=data.appointment?data.comments:'';
        applicant_info['close_status']=data.close_status?data.close_status:'';
        applicant_info['reopen_notes1']=data.reopen_notes1?data.reopen_notes1:'';
        applicant_info['reopen_notes2']=data.reopen_notes2?data.reopen_notes2:'';
        applicant_info['reopen_notes3']=data.reopen_notes3?data.reopen_notes3:'';
        applicant_info['reopen_status1']=data.reopen_status1?data.reopen_status1:'';
        applicant_info['reopen_status2']=data.reopen_status2?data.reopen_status2:'';
        applicant_info['reopen_status3']=data.reopen_status3?data.reopen_status3:'';
        applicant_info['reopen_by1']=data.reopen_by1?data.reopen_by1:'';
        applicant_info['reopen_by2']=data.reopen_by2?data.reopen_by2:'';
        applicant_info['reopen_by3']=data.reopen_by3?data.reopen_by3:'';
        applicant_info['reopen_on']=data.reopen_on?data.reopen_on:'';
        applicant_info['assigner_role']=data.assigner_role?data.assigner_role:'';
        applicant_info['assigned_role']=data.assigned_role?data.assigned_role:'';
        applicant_info['is_autofit']=data.is_autofit?data.is_autofit:'';
        applicant_info['next_visa']=res.next_visa;
        
        localStorage.setItem('applicant-details',this.encryptData(applicant_info));
        callback(applicant_info);
      }
      /* else {
        callback({status:res.status,message:res.message});
      } */
    });
  }

  getWorkListCount(data,callback){
    let rdata = {count:-1}
    this.postAPI(environment.API_URL + "transaction/worklist-count",data).subscribe((res)=>{
      if(res.status==environment.SUCCESS_CODE) {
        rdata.count = res.count;
        callback(rdata);
      }
      callback(rdata);
    });
  }


  getHeightWeight(callback){

   this.getAPI(environment.VITALS_KIOSK).subscribe((res)=>{
       callback(res)
   
   });
}
AppointmentToken:any
AppointmentGetToken() {
  let data = {
    'loginname': 'Superadmin',
    'password': this.encrypt('@@@@@@',environment.SECRET_KEY)
  };

  this.http.post(environment.APPOINTMENT_URL +'api/auth/token', data).subscribe((res:any)=>{
    console.log("AppointmentGetToken",res);
    let token = String(res.access)
    if(res.status==environment.SUCCESS_CODE){
     this.AppointmentToken = localStorage.setItem('appointment-token',token);
    }
  })
 
}

AppointmentGetAPI(url: any): Observable<any> {
  if (!this.AppointmentToken) {
    // If no token exists, get a new one first
    let tokenData = {
      'loginname': 'Superadmin',
      'password': this.encrypt('@@@@@@',environment.SECRET_KEY)
    };

    return this.http.post(environment.APPOINTMENT_URL + 'api/auth/token', tokenData).pipe(
      switchMap((tokenRes:any) => {
        if (tokenRes.access) {
          this.AppointmentToken = tokenRes;
          localStorage.setItem('appointment-token', tokenRes.access);
          
          let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + tokenRes.access
          });
          
          return this.http.get(environment.APPOINTMENT_URL + url, { headers: headers });
        }
        throw new Error('Could not obtain token');
      })
    );
  }

  let headers = new HttpHeaders({ 
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + this.AppointmentToken.access
  });
  
  return this.http.get(environment.APPOINTMENT_URL + url, { headers: headers });
}

AppointmentPostAPI(url:any, data:any): Observable<any> {
  if (!this.AppointmentToken) {
    // If no token exists, get a new one first
    let tokenData = {
      'loginname': 'Superadmin',
      'password': this.encrypt('@@@@@@',environment.SECRET_KEY)
    };

    return this.http.post(environment.APPOINTMENT_URL + 'api/auth/token', tokenData).pipe(
      switchMap((tokenRes:any) => {
        if (tokenRes.access) {
          this.AppointmentToken = tokenRes;
          localStorage.setItem('appointment-token', tokenRes.access);
          
          let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + tokenRes.access
          });
          
          return this.http.post(environment.APPOINTMENT_URL + url, data, { headers: headers });
        }
        throw new Error('Could not obtain token');
      })
    );
  }

  let headers = new HttpHeaders({ 
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + this.AppointmentToken.access
  });
  
  return this.http.post(environment.APPOINTMENT_URL + url, data, { headers: headers });
}


}